// Hismile V34 Luxury Theme - Online Store 2.0 JavaScript

document.addEventListener('DOMContentLoaded', function () {
  initGallery();
  initPackSelector();
  initFaqAccordion();
  initBeforeAfterSlider();
  initUgcVideos();
});

// Gallery Thumbnails
function initGallery() {
  const mainImage = document.getElementById('MainProductImage');
  const thumbs = document.querySelectorAll('.thumb-item');
  if (!mainImage || !thumbs.length) return;

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const targetSrc = thumb.getAttribute('data-image-src');
      if (targetSrc) {
        mainImage.src = targetSrc;
      }
    });
  });
}

// Pack Selector & Shopify Cart Quantity Mapping
function initPackSelector() {
  const packCards = document.querySelectorAll('.pack-card');
  const quantityInput = document.getElementById('ProductQuantity');
  const priceDisplay = document.getElementById('CurrentPriceDisplay');
  const stickyPrice = document.getElementById('StickyPrice');
  const stickyTitle = document.getElementById('StickyTitle');
  const form = document.getElementById('MainProductForm');

  if (!packCards.length || !quantityInput) return;

  packCards.forEach(function (card) {
    card.addEventListener('click', function () {
      packCards.forEach(c => c.classList.remove('selected'));
      card.classList.add('selected');

      const qty = parseInt(card.getAttribute('data-quantity'), 10) || 1;
      const price = card.getAttribute('data-price') || '70';
      const title = card.getAttribute('data-title') || '1 Bottle';

      // Set quantity input for Shopify product form
      quantityInput.value = qty;

      // Update visible prices
      if (priceDisplay) {
        priceDisplay.textContent = price + ' SAR';
      }
      if (stickyPrice) {
        stickyPrice.textContent = price + ' SAR';
      }
      if (stickyTitle) {
        stickyTitle.textContent = title;
      }
    });
  });

  // Main BUY NOW button handler: submits directly to Shopify checkout
  const buyNowButtons = document.querySelectorAll('.btn-buy-now, .sticky-buy-button');
  buyNowButtons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (form) {
        // Direct checkout submission
        const returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        returnInput.value = '/checkout';
        form.appendChild(returnInput);
        form.submit();
      }
    });
  });
}

// FAQ Accordion
function initFaqAccordion() {
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function (item) {
    const question = item.querySelector('.faq-question');
    if (question) {
      question.addEventListener('click', function () {
        const isActive = item.classList.contains('active');
        faqItems.forEach(i => i.classList.remove('active'));
        if (!isActive) {
          item.classList.add('active');
        }
      });
    }
  });
}

// Interactive Before / After Slider
function initBeforeAfterSlider() {
  const stage = document.querySelector('.ba-stage');
  const beforeLayer = document.querySelector('.ba-before');
  if (!stage || !beforeLayer) return;

  let isDragging = false;

  function setSliderPosition(x) {
    const rect = stage.getBoundingClientRect();
    let percent = ((x - rect.left) / rect.width) * 100;
    percent = Math.max(0, Math.min(100, percent));
    beforeLayer.style.clipPath = `inset(0 ${100 - percent}% 0 0)`;
  }

  stage.addEventListener('mousedown', function (e) {
    isDragging = true;
    setSliderPosition(e.clientX);
  });

  window.addEventListener('mouseup', function () {
    isDragging = false;
  });

  window.addEventListener('mousemove', function (e) {
    if (isDragging) {
      setSliderPosition(e.clientX);
    }
  });

  stage.addEventListener('touchstart', function (e) {
    if (e.touches.length) {
      setSliderPosition(e.touches[0].clientX);
    }
  });

  stage.addEventListener('touchmove', function (e) {
    if (e.touches.length) {
      setSliderPosition(e.touches[0].clientX);
    }
  });
}

// UGC Videos Interaction
function initUgcVideos() {
  const cards = document.querySelectorAll('.ugc-card');
  cards.forEach(function (card) {
    card.addEventListener('click', function () {
      const playIcon = card.querySelector('.ugc-play-icon');
      if (playIcon) {
        playIcon.style.opacity = playIcon.style.opacity === '0' ? '1' : '0';
      }
    });
  });
}
